import axios from "axios";
import {IdleTimer} from "./idletime";
import jwtAuthService from "./app/services/jwtAuthService";

const customConstants = {
    LOGIN_TIMEOUT: 1000 * 60 * 30, // miliseconds
    IDLE_TIMEOUT: 10, // minutes
    API_URL: (process.env.REACT_APP_API_URL) ? process.env.REACT_APP_API_URL : 'http://169.62.55.86:8098',
    //API_URL: (process.env.REACT_APP_API_URL) ? 'https://4c74-85-107-110-17.ngrok-free.app' : 'https://4c74-85-107-110-17.ngrok-free.app/',
    LOGIN_URL: process.env.REACT_APP_LOGIN_URL,
    BASE_URL: process.env.REACT_APP_BASE_URL,
    AVAILABLERESULTS: ["AGE",
        "LIVENESSAGE",
        "FACEBLACKLISTSCORE",
        "FACELIVENESSFACECONSAVG",
        "FACELIVENESSFACECONSPER",
        "GENDER",
        "PHOTOCHEAT",
        "HOLOGRAM",
        "HOLOGRAMFACE",
        "HOLOGRAMIDSIMILARITY",
        "FACELIVENESS",
        "FACE",
        "HIDDENPHOTO",
        "SIGNATUREPHOTO",
        "GUILLOCHEVERIFICATION",
        "RAINBOWVERIFICATION",
        "MRZNFCSIMILARITY",
        "MRZOCRSIMILARITY",
        "NFCMRZSIMILARITY",
        "NFCOCRFACESIMILARITY",
        "NFCOCRSIMILARITY",
        "DRIVERBARCODEIDMATCH",
        "IDCARDBARCODEIDMATCH",
        "IDDOCIDMATCH",
        "IDDOCNAMEMATCH",
        "IDDOCSURNAMEMATCH",
        "LIVENESSAGE",
        "LIVENESSFACEBLACKLISTSCORE",
        "LIVENESSGENDER",
        "FACELIVENESSGESTURE",
        "MRZBIRTHDATECHECKSUM",
        "MRZEXPDATECHECKSUM",
        "MRZDOCNUMCHECKSUM",
        "MRZEXPDATECHECKSUMVALID",
        "MRZBIRTHDATECHECKSUMVALID",
        "MRZDOCNUMCHECKSUMVALID",
        "HOLOGRAMSERIALSIMILARITY",
        "HOLOGRAMBDATESIMILARITY",
        "HOLOGRAMEDATESIMILARITY",
        "AMLVALIDATION",
        "NVIPROVEIDWITHHOLDER",
        "SECONDARYIDFILE",
        "SCREENATTACK",
        "SIGNATUREPHOTO",
        "OLDIDFRONT",
        "OCRLETTERCASEMATCH",
        "OCRMRZSIMILARITY",
        "OCRNFCFACESIMILARITY",
        "OCRNFCSIMILARITY",
        "OLDIDSECONDARYINFORMATION",
        "FACELIVENESSEYEMOVEMENT",
        "FACESEARCHEXISTENCE",
        "FACELIVENESSAI"],
    SITE_LOGIN: true, // true for development or customer installation
    PAGE_SIZE: 50,
    REMEMBER_USER: true,
    OTP_TIMEOUT: 180,
    INCLUDE_ASSISTBOX_SDK: true,
    GTM: false
};

function redirectSigning() {
    if (!(['/session/sign-in', '/session/forgot-password', '/session/reset-password', '/session/register', '/web-sdk/demo', '/web-sdk/colendi', '/privacy', "/session/mfa"].includes(window.location.pathname))) {

        localStorage.removeItem("auth_user");
        localStorage.removeItem("_atoken");
        localStorage.removeItem("_rtoken");
        localStorage.removeItem("grants");
        localStorage.removeItem("jwt_token");

        axios.post(customConstants.API_URL + '/oauth/logout').then(function () {
            if (customConstants.SITE_LOGIN === false) {
                window.location = customConstants.LOGIN_URL
            } else {
                window.location = '/session/sign-in?timeout=true';
            }
        })

    }
}

axios.interceptors.response.use(
    async function (response) {

        console.log(response);
        if (response == 'Error: Request failed with status code 401') {
            redirectSigning();
        }
        if (((+new Date() - parseInt(localStorage.getItem('last_update')))) > customConstants.LOGIN_TIMEOUT) {
            localStorage.setItem('last_update', +new Date());
            redirectSigning();
        }

        return response;
    }, function (error) {

        if (error.response.status === 401) {
            redirectSigning();
        }

        return Promise.reject(error);
    });

window.axios = axios;

const timer = new IdleTimer(() => redirectSigning(), 1000 * 60 * customConstants.IDLE_TIMEOUT);
timer.activate();


if (localStorage.getItem('last_update', '') === null) {
    localStorage.setItem('last_update', +new Date());

    setTimeout(function () {
        redirectSigning();
    }, customConstants.LOGIN_TIMEOUT)

} else {
    if (((+new Date() - parseInt(localStorage.getItem('last_update')))) > customConstants.LOGIN_TIMEOUT) {
        localStorage.setItem('last_update', +new Date());
        redirectSigning();
    } else {
        setTimeout(function () {
            redirectSigning();
        }, customConstants.LOGIN_TIMEOUT)
    }
}

export default customConstants;
